import styled from "styled-components";
import { Link } from "react-router-dom";

export const AccordionSection = styled.section`
  display: flex;
  flex-direction: column;
  margin-top: 215px;
  width: 100%;
  max-width: 1000px;

  @media (max-width: 768px) {
    margin-top: 0;
    place-self: center;
    min-height: calc(100vh - 356px);
    height: 100%;
  }
`;

export const BackButton = styled(Link)`
  display: flex;
  gap: 5px;
  align-items: center;
  width: fit-content;
  padding: 10px;
  margin-bottom: 25px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  background-color: ${({ theme }) => theme.colors.blue};
  color: #fff;
  border-radius: 4px;

  &:hover {
    text-decoration: none;
    color: #fff;
  }
`;

export const HeaderContainer = styled.header`
  display: flex;
  flex-direction: column;

  span {
    font-size: 0.75rem;
    color: #5e5e5e;
    margin-bottom: 22px;
    color: ${({ theme }) => theme.colors.gray};
    display: flex;
    align-items: center;
  }

  h1 {
    font-size: 1.4375rem;
    margin-bottom: 12px;
    color: ${({ theme }) => theme.colors.blue};
  }

  h2 {
    font-size: 0.9375rem;
    margin-bottom: 18px;
    color: ${({ theme }) => theme.colors.gray};
    line-height: 30px;
    font-weight: 400;
  }

  p {
    color: ${({ theme }) => theme.colors.black};
    font-weight: bold;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  & > .accordion {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-bottom: 15px;

    & > .card:not(:first-of-type):not(:last-of-type) {
      border-bottom: 1px solid #0000ff;
      border-radius: 4px;
    }

    & > .card {
      width: 100%;
      border: 1px solid #0000ff;
      border-radius: 4px;

      .card-header {
        background-color: white;
        border: none;
        padding: 13px 25px;
        color: #0000ff;
        font-size: 1.1rem;
        line-height: 22px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
      }

      .card-body {
        padding: 0 25px 10px;
        color: #7a7a7a;
        font-size: 1rem;
        line-height: 22px;
        font-weight: 300;

        b {
          font-weight: 700;
        }

        a {
          color: #000fff;
          cursor: pointer;
        }
      }
    }
  }
`;
